import { Icon, IconProps } from "./Icon";

export function IconEye(props: IconProps) {
  return (
    <Icon {...props}>
      <path d="M12 20C7.11 20 2.67 17.11.12 12.25L0 12l.12-.23C2.67 6.92 7.11 4 12 4s9.32 2.91 11.87 7.77L24 12l-.12.24C21.32 17.11 16.88 20 12 20ZM1.13 12c2.39 4.4 6.44 7 10.87 7s8.47-2.61 10.86-7C20.47 7.62 16.43 5 12 5S3.52 7.62 1.13 12Zm10.92-4a4 4 0 1 0 4 4 4 4 0 0 0-4-4Zm0 7a3 3 0 1 1 3-3 3 3 0 0 1-3 3Z" />
    </Icon>
  );
}
